"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var __1 = require("../../../");
var react_1 = require("@escolalms/sdk/lib/react");
var formik_1 = require("formik");
var react_2 = require("react");
var react_i18next_1 = require("react-i18next");
var styled_components_1 = __importStar(require("styled-components"));
var Header = styled_components_1.default.header(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding-bottom: 18px;\n  border-bottom: 1px solid ", ";\n  margin-bottom: 24px;\n"], ["\n  padding-bottom: 18px;\n  border-bottom: 1px solid ", ";\n  margin-bottom: 24px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.primaryColor;
});
var NoteModalWrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  & form {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n  }\n"], ["\n  & form {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n  }\n"])));
var ButtonsWrapper = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 26px;\n"], ["\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 26px;\n"])));
var ModalNote = function (_a) {
    var currentNote = _a.currentNote, newNoteData = _a.newNoteData, onClose = _a.onClose;
    var initialValues = {
        noteValue: currentNote ? currentNote.value : "",
    };
    var _b = (0, react_2.useContext)(react_1.EscolaLMSContext), fetchBookmarkNotes = _b.fetchBookmarkNotes, createBookmarkNote = _b.createBookmarkNote, updateBookmarkNote = _b.updateBookmarkNote;
    var t = (0, react_i18next_1.useTranslation)().t;
    return ((0, jsx_runtime_1.jsxs)(NoteModalWrapper, { children: [(0, jsx_runtime_1.jsx)(Header, { children: (0, jsx_runtime_1.jsx)(__1.Title, { children: t("Bookmarks.Notes") }) }), (0, jsx_runtime_1.jsx)(formik_1.Formik, __assign({ initialValues: initialValues, validate: function (values) {
                    var errors = {};
                    if (!values.noteValue) {
                        errors.noteValue = "Required";
                    }
                    return errors;
                }, onSubmit: function (values) {
                    currentNote
                        ? updateBookmarkNote(currentNote.id, {
                            value: values.noteValue,
                            bookmarkable_id: currentNote.bookmarkable_id,
                            bookmarkable_type: currentNote.bookmarkable_type,
                        }).then(function () {
                            fetchBookmarkNotes(), onClose();
                        })
                        : createBookmarkNote({
                            value: values.noteValue,
                            bookmarkable_id: newNoteData === null || newNoteData === void 0 ? void 0 : newNoteData.id,
                            bookmarkable_type: newNoteData === null || newNoteData === void 0 ? void 0 : newNoteData.type,
                        }).then(function () {
                            fetchBookmarkNotes(), onClose();
                        });
                } }, { children: function (_a) {
                    var _b;
                    var values = _a.values, handleChange = _a.handleChange, handleSubmit = _a.handleSubmit, isSubmitting = _a.isSubmitting;
                    return ((0, jsx_runtime_1.jsxs)("form", __assign({ onSubmit: handleSubmit }, { children: [(0, jsx_runtime_1.jsx)(__1.TextArea, { name: "noteValue", id: "noteValue", label: t("Bookmarks.YourNote", {
                                    defaultValue: "Your note",
                                }), placeholder: (_b = t("Bookmarks.WriteNote", {
                                    defaultValue: "Write a note...",
                                })) !== null && _b !== void 0 ? _b : undefined, value: values.noteValue, onChange: handleChange }), (0, jsx_runtime_1.jsxs)(ButtonsWrapper, { children: [(0, jsx_runtime_1.jsx)(__1.Button, __assign({ type: "button", mode: "secondary", onClick: onClose }, { children: t("Bookmarks.Cancel") })), (0, jsx_runtime_1.jsx)(__1.Button, __assign({ type: "submit", mode: "secondary", disabled: isSubmitting }, { children: t("Bookmarks.".concat(currentNote ? "Update" : "Add")) }))] })] })));
                } }))] }));
};
exports.default = (0, styled_components_1.withTheme)((0, styled_components_1.default)(ModalNote)(templateObject_4 || (templateObject_4 = __makeTemplateObject([""], [""]))));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
